import React from 'react';
import FadeIn from '../components/FadeIn';

const Sparkathon: React.FC = () => {
    return (
        <div className="container mx-auto px-8 py-16 text-center text-[#001d36]">

            <FadeIn>
                <h1 className="text-5xl font-bold mb-8">Sparkathon</h1>
            </FadeIn>

            <FadeIn delay={0.1}>
                <div className="flex justify-center mt-8">
                    <img
                        src="/DSC00861 (4).jpg"
                        alt="everyone"
                        className="w-full h-3/4 object-cover rounded-lg shadow-lg"
                    />
                </div>
            </FadeIn>

            <FadeIn delay={0.1}>
                <div className="p-8 rounded-lg text-[#001d36] shadow-m text-center">
                    <p className="text-lg font-beezee leading-relaxed mb-4">
                        I, along with everyone at{' '}
                        <a
                            href="https://www.pomonaventures.website"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline hover:text-cyan-600 font-bold"
                        >
                            Pomona Ventures
                        </a>{' '} (the largest entrepreneurship club at the Claremont Colleges), have a commitment to encourage entrepreneurship, and Sparkathon is a perfect way to ignite the spark of innovation in individuals and communities, fostering an environment where ideas can flourish and impactful solutions can emerge.
                    </p>
                    <p className="text-lg font-beezee leading-relaxed mb-4">
                        Sparkathon is an innovative, impact-driven design thinking competition challenges teams of 4 - 6 students to collaboratively
                        solve some of the most pressing societal problems. This year, we challenged students to ideate answers to "How can American universities effectively reduce waste? (e.g., time, energy, emotions, plastic, and other forms of waste)"
                    </p>
                    <p className="text-lg font-beezee leading-relaxed mb-4">
                        What was particularly fascinating to see was all the different perspectives participants took with the definition of "waste". We saw solutions around the topic of e-waste, waste of time, waste of resources, and waste of first impressions.
                    </p>
                    <p className="text-lg font-beezee leading-relaxed mb-4">
                        Organizing the event, I was fortunate to have incredible people around me who helped on the financing, logistics, and marketing initiatives. Together, we were able to plan one of the best Sparkathons ever, raising several thousands of dollars, including $2.25k for the winners of Sparkathon and having over 125 participants and 24 teams compete!
                    </p>
                    <a
                        href="https://www.sparkathon.org"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline hover:text-cyan-600 font-bold"
                    >
                        Click here to learn more!
                    </a>
                </div>
            </FadeIn>

            <FadeIn delay={0.1}>
                <div className="mt-16">
                    <div className="grid grid-cols-2 gap-6">
                        <img src="/DSC00842 (1).jpg" alt="judges" className="w-full h-full object-cover rounded-lg shadow-lg" />
                        <img src="/DSC00839.jpg" alt="pitch" className="w-full h-full object-cover rounded-lg shadow-lg" />
                        <img src="/DSC00656.jpg" alt="me" className="w-full h-full object-cover rounded-lg shadow-lg" />
                        <img src="/DSC00874.jpg" alt="me" className="w-full h-full object-cover rounded-lg shadow-lg" />
                    </div>
                </div>
            </FadeIn>

        </div>
    );
};

export default Sparkathon;
